import React, { useState } from 'react';

import Link from 'next/link';

import Button from './button';

import useI18n from '../../hooks/use-i18n';
import { socialLinks } from '../../links.config';
import CountrySelector from '../revamp/country-selector';
import DisclaimerModal from '../revamp/disclaimer-modal';

import '../../styles/jp-revamp/jp-footer.scss';

const JpFooter = () => {
  const i18n = useI18n();

  const COUNTRY_LANGUAGE = i18n.activeLocale;
  const codes = COUNTRY_LANGUAGE.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const socialMedia = socialLinks[country] || socialLinks.sg;

  const contact = i18n.t('contact');
  const footer = i18n.t('footer');
  const footerTranslations = i18n.t('new_landing_page').footer;

  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const onModalClose = () => {
    setShowDisclaimer(false);
  };

  const onModalOpen = () => {
    setShowDisclaimer(true);
  };

  return (
    <footer>
      <section className="footer-wrapper">
        <div className="detail-section-wrapper">
          <div className="link-wrapper">
            <div className="contact-details">
              <h3
                data-lokalise=""
                data-key="new_landing_page::footer::footer_content_1"
                role="presentation"
              >
                {footerTranslations.footer_content_1}
              </h3>
              <Button className="contact-us" href={contact[country].line_link} externalLink={true} target="_blank">
                <>
                  <img src="/img/jp-home-page/icons/line-dark-theme.svg" alt="line" data-gumlet="false" />
                  <span
                    data-lokalise=""
                    data-key={`contact::${country}::line_name`}
                    role="presentation"
                  >
                    {contact[country].line_name}
                  </span>
                </>
              </Button>
              <Button className="contact-us" href={`mailto:${contact[country].email}`} externalLink={true} as="">
                <>
                  <img src="/img/jp-home-page/icons/email.svg" alt="email" data-gumlet="false" />
                  <span
                    data-lokalise=""
                    data-key={`contact::${country}::email`}
                  >
                    {contact[country].email}
                  </span>
                </>
              </Button>
              <Button className="contact-us" href={`tel:${contact[country].tel}`} externalLink={true} as="">
                <>
                  <img src="/img/jp-home-page/icons/telephone.svg" alt="telephone" data-gumlet="false" />
                  <span
                    data-lokalise=""
                    data-key={`contact::${country}::tel`}
                  >
                    {contact[country].tel}
                  </span>
                </>
              </Button>
            </div>
            <div className="useful-information">
              <h3>{footerTranslations.footer_content_2}</h3>
              <Link href="/[lng]/blog/" as={`/${i18n.activeLocale}/blog/`}>
                <span className="blog-link">
                  {footerTranslations.blog}
                </span>
              </Link>
            </div>
          </div>
          <div className="social-media-icons">
            <Button className="social-media" href={socialMedia.facebook} externalLink={true} target="_blank">
              <img src="/img/jp-home-page/icons/facebook.svg" alt="facebook" data-gumlet="false" />
            </Button>
            <Button className="social-media" href={socialMedia.instagram} externalLink={true} target="_blank">
              <img src="/img/jp-home-page/icons/instagram.svg" alt="instagram" data-gumlet="false" />
            </Button>
            <Button className="social-media" href={socialMedia.tiktok} externalLink={true} target="_blank">
              <img src="/img/jp-home-page/icons/tik-tok.svg" alt="tik-tok" data-gumlet="false" />
            </Button>
          </div>
        </div>
        <div className="footer-bottom-wrapper">
          <div className="country-selector-wrapper">
            <CountrySelector locale={i18n.activeLocale} />
          </div>
          <div className="terms-and-conditions">
            <Link
              href="/[lng]/legal/specified-commercial-transactions"
              as={`/${i18n.activeLocale}/legal/specified-commercial-transactions`}
            >
              <span
                data-lokalise=""
                data-key="new_landing_page::footer::footer_links::footer_link_one"
              >
                {footerTranslations.footer_links.footer_link_one}
              </span>
            </Link>
            <Link href="/[lng]/privacy" as={`/${i18n.activeLocale}/privacy`}>
              <span
                data-lokalise=""
                data-key="new_landing_page::footer::footer_links::footer_link_two"
              >
                {footerTranslations.footer_links.footer_link_two}
              </span>
            </Link>
            <span
              data-lokalise=""
              data-key="new_landing_page::footer::footer_links::footer_link_three"
              role="presentation"
              onClick={onModalOpen}
            >
              {footerTranslations.footer_links.footer_link_three}
            </span>
            <Link href="/[lng]/website-terms-and-conditions" as={`/${i18n.activeLocale}/website-terms-and-conditions`}>
              <span
                data-lokalise=""
                data-key="new_landing_page::footer::footer_links::footer_link_four"
              >
                {footerTranslations.footer_links.footer_link_four}
              </span>
            </Link>
            <span
              data-lokalise=""
              data-key="new_landing_page::footer::terms_and_conditions"
            >
              {footerTranslations.terms_and_conditions}
            </span>
          </div>
        </div>
        <div className="iso-container">
          <div className="iso-logo-container">
            <img src="/img/bsi_white.svg" data-gumlet="false" alt="ISO Logo" />
          </div>
          <p
            data-key="footer::iso_description"
            data-lokalise=""
          >
            {footer.iso_description}
          </p>
        </div>
        <div className="terms-and-conditions mobile">
          <Link
            href="/[lng]/legal/specified-commercial-transactions"
            as={`/${i18n.activeLocale}/legal/specified-commercial-transactions`}
          >
            <span
              data-lokalise=""
              data-key="new_landing_page::footer::footer_links::footer_link_one"
            >
              {footerTranslations.footer_links.footer_link_one}
            </span>
          </Link>
          <Link href="/[lng]/privacy" as={`/${i18n.activeLocale}/privacy`}>
            <span
              data-lokalise=""
              data-key="new_landing_page::footer::footer_links::footer_link_two"
            >
              {footerTranslations.footer_links.footer_link_two}
            </span>
          </Link>
          <span
            data-lokalise=""
            data-key="new_landing_page::footer::footer_links::footer_link_three"
            role="presentation"
            onClick={onModalOpen}
          >
            {footerTranslations.footer_links.footer_link_three}
          </span>
          <Link href="/[lng]/website-terms-and-conditions" as={`/${i18n.activeLocale}/website-terms-and-conditions`}>
            <span
              data-lokalise=""
              data-key="new_landing_page::footer::footer_links::footer_link_four"
            >
              {footerTranslations.footer_links.footer_link_four}
            </span>
          </Link>
          <span
            data-lokalise=""
            data-key="new_landing_page::footer::terms_and_conditions"
          >
            {footerTranslations.terms_and_conditions}
          </span>
        </div>
      </section>
      {showDisclaimer && (
      <DisclaimerModal onClose={onModalClose} />
      )}
    </footer>
  );
};

export default JpFooter;
